import React, { useCallback, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
// import Bitcoin from '../../assets/images/cryptocurrency/bitcoin.png';
import { userInfoStore } from '../../store/userInfoStore';
import { useAmountValidation } from '../../hooks/useAmountValidation';
import { regexByPrecision } from '../../core/helpers/regexByPrecision';
// import cryptogreen from '../../assets/images/cryptocurrency/green-usd.png';
// import cryptogreen from '../../assets/images/cryptocurrency/usdImg.png';
import useTranslation from '../../hooks/useTranslation';
import { TranslationKeys } from '../../core/constants/translationKeys';
import { handleBetAmountLimits } from '../../core/helpers/handleBetAmountLimits';
import { NumPad } from '../index';
import { userSettingsStore } from '../../store/userSettingsStore';
import { isMobile } from '../../core/helpers/isMobile';
import { cryptoCurrencies } from '../../core/constants/cryptoCurrencies';
import { isPG } from '../../core/helpers/skinHelper';
import { useDebounce } from '../../hooks/useDebounce';
import './bet-amount.scss';

const BetAmount = observer(({ isDisabled }) => {
  const {
    betAmount,
    setBetAmount,
    setDouble,
    setHalve,
    limits,
    precision,
    displayCurrency,
    currencyCode,
    exchangedBetAmount,
    currencyCodeAbbr,
    sendExchangeAmount,
    setExchangedBetAmount,
  } = userInfoStore;
  const { isNumpadActive, setIsNumpadActive } = userSettingsStore;
  const t = useTranslation();
  const debouncedValue = useDebounce(betAmount, 500);

  const handleChangeBetAmount = useCallback(
    ({ changeBet }) => {
      setBetAmount(changeBet);
    },
    [setBetAmount]
  );

  const handleBlurBetAmount = useCallback(
    () => handleBetAmountLimits(limits?.maxBet, limits?.minBet, betAmount, setBetAmount, precision),
    [betAmount, limits, setBetAmount, precision]
  );

  const { onChange: handleChangeInput } = useAmountValidation(
    handleChangeBetAmount,
    limits,
    regexByPrecision(precision)
  );

  const isNumpadActiveSetter = useCallback(
    (props) => {
      setIsNumpadActive(props);
      handleBlurBetAmount();
    },
    [handleBlurBetAmount, setIsNumpadActive]
  );

  const handleClickBetAmountInput = useCallback(
    (e) => {
      if (isMobile()) {
        e.stopPropagation();
        document.activeElement.blur();
        isNumpadActiveSetter(true);
      }
    },
    [isNumpadActiveSetter]
  );

  useEffect(() => {
    if (Number.isInteger(debouncedValue)) {
      sendExchangeAmount(debouncedValue);
    } else {
      setExchangedBetAmount(0);
    }
  }, [debouncedValue, sendExchangeAmount, setExchangedBetAmount]);

  return (
    <>
      {isPG() ? (
        <NumPad isNumpadActive={isNumpadActive} setIsNumpadActive={isNumpadActiveSetter} />
      ) : null}
      <div className='cpt-bet-amount-wrapper'>
        <div className='cpt-input-top-titles-content'>
          <span className='cpt-input-top-title'>{t(TranslationKeys.BetAmount)}</span>
          {!isPG() && (
            <div className='cpt-input-top-titles-content cpt-with-crypto'>
              <span className='cpt-input-top-title chip-total'>{exchangedBetAmount}</span>
              <div className='cpt-crypto-img-with-title'>
                <p
                  className={`cpt-bet-amount-inner-img currency-image ${
                    displayCurrency ? cryptoCurrencies[displayCurrency] : ''
                  }`}
                />
              </div>
            </div>
          )}
        </div>
        <div
          className={`cpt-row-inner-items-container three-buttons ${isDisabled ? 'disabled' : ''}`}
        >
          <div className='cpt-input-main-bg'>
            <input
              inputMode='none'
              type='text'
              value={betAmount === null ? '' : betAmount}
              onBlur={handleBlurBetAmount}
              onChange={handleChangeInput}
              maxLength={
                betAmount && String(+betAmount).includes('.')
                  ? String(betAmount).indexOf('.') + 1 + precision
                  : 15
              } // 15 just to allow paste
              className='cpt-bet-section-input'
              onClick={isPG() ? handleClickBetAmountInput : null}
              readOnly={isDisabled}
            />
            <div className='cpt-crypto-img-with-input'>
              {/* <img src={Bitcoin} alt='' /> */}
              <p
                className={`cpt-bet-amount-inner-img currency-image
                 ${isPG() ? '' : cryptoCurrencies[currencyCodeAbbr]}
                 ${isDisabled ? 'disabled' : ''}`}
                data-cur={currencyCode}
              />
              {/* <img src={Bitcoin} alt='' className='cpt-bet-amount-inner-img' /> */}
            </div>
            <div className='cpt-min-buttons-container'>
              {/* ToDo add class selected when need */}
              <button
                className={`cpt-bet-min-button ${limits?.minBet === +betAmount ? 'disabled' : ''}`}
                onClick={setHalve}
              >
                1/2
              </button>
              {/* ToDo add class selected when need */}
              <button
                className={`cpt-bet-min-button ${limits?.maxBet === +betAmount ? 'disabled' : ''}`}
                onClick={setDouble}
              >
                x2
              </button>
              {/* ToDo add class selected when need */}
              <button
                className={`cpt-bet-min-button ${limits?.maxBet === +betAmount ? 'disabled' : ''}`}
                onClick={() => setBetAmount(limits.maxBet)}
              >
                Max
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
});
export default BetAmount;
